module.exports = __webpack_public_path__ + "static/img/200203.4a674ed8.png";